import { ReactComponent as CopyIcon } from 'assets/images/icons/copy.svg'
import { ReactComponent as EditIcon } from 'assets/images/icons/edit_2.svg'
import { ReactComponent as MoveToCategoryIcon } from 'assets/images/icons/move_to_category_icon.svg'
import { ReactComponent as DeleteIcon } from 'assets/images/icons/trash_2.svg'
import { ReactComponent as PinToCategoryIcon } from 'assets/images/icons/pin_to_category.svg'
import { ReactComponent as UnpinToCategoryIcon } from 'assets/images/icons/unpin_from_category.svg'

import { ResponseCardDropdownStyle } from "../styles"
import { connect } from 'react-redux'
import { pinToCategory_action, setCurrentResponseDropdown, setIsCopyingLoading, setResponseDropdoenStatus, setResponseDropdownPosition, toggleCategoryModal_action, toggleDeleteCategoryModal_action, toggleDeleteContentModal_action, toggleMoveToCategoryModal_action } from 'store/actions'
import { checkUser_for_admin_or_owner, checkUser_for_admin_or_owner_or_editor, copyTextHandler, generateSlug, handleApiError } from 'utils/helpers'
import { getContentByUUID_api, updateCopyCount_api } from 'store/apis'
import { history } from 'store/store'

const ResponseCardDropdown = (props) => {
  const { user, pinToCategory, toggleDeleteContentModal, setIsCopyingLoading, setResponseDropdoenStatus, toggleMoveToCategoryModal, currentResponseDropdown } = props

  const triggerCopyTextHandler = async () => {

    let type = 'plain';
    let e = document.getElementById(`responseDropdownButton-${currentResponseDropdown?.id}`);

    try {
      // e.stopPropagation()
      const ActionButtons = e.closest('.action-buttons')

      ActionButtons.classList.add('show')
      if (currentResponseDropdown.content) {
        await copyTextHandler(type, currentResponseDropdown)
      } else {
        setIsCopyingLoading(true)
        const data = await getContentByUUID_api(currentResponseDropdown.uuid)
        if (data && data.id) {
          await copyTextHandler(type, data)
        }
        setIsCopyingLoading(false)
      }
      setResponseDropdoenStatus(false)

      const ALL_ACTION_BUTTONS = document.getElementsByClassName('action-buttons')
      for (let i = 0; i < ALL_ACTION_BUTTONS.length; i++) {
        ALL_ACTION_BUTTONS[i].classList?.remove('show')
      }
      const ALL_COPYBUTTONS = [...document.getElementsByClassName('copyButton'), ...document.getElementsByClassName('dropdown-toggle')]
      for (let i = 0; i < ALL_COPYBUTTONS.length; i++) {
        ALL_COPYBUTTONS[i].classList?.remove('green')
        ALL_COPYBUTTONS[i].classList?.add('black')
        ALL_COPYBUTTONS[i].querySelector('span').textContent = 'COPY'
      }
      ActionButtons.classList.add('show')
      const BUTTONS = [ActionButtons.querySelector('.copyButton'), ActionButtons.querySelector('.dropdown-toggle')]
      if (BUTTONS.length > 0) {
        setTimeout(() => {
          BUTTONS[0].querySelector('span').textContent = 'COPIED'
          BUTTONS.forEach((button) => {
            button.classList.remove('black')
            button.classList.add('green')
          })

          setResponseDropdoenStatus(true)
        }, 100);

        setTimeout(() => {
          setResponseDropdoenStatus(false)
          BUTTONS[0].querySelector('span').textContent = 'COPY'
          BUTTONS.forEach((button) => {
            button.classList.remove('green')
            button.classList.add('black')
          })
          ActionButtons.classList.remove('show')
        }, 1800)
      }

      // Update view/use count
      updateCopyCount_api(currentResponseDropdown.id)
    } catch (error) {
      handleApiError(error)
    }
  }

  return (
    <ResponseCardDropdownStyle>
      <div className='dropdownChild' onClick={triggerCopyTextHandler}>
        <CopyIcon />
        Plain Copy
      </div>
      {checkUser_for_admin_or_owner_or_editor(currentResponseDropdown, user) && (
        <div className='dropdownChild' onClick={(e) => {
          history.push(`/responses/edit/${generateSlug(currentResponseDropdown)}`)

          setTimeout(() => setResponseDropdoenStatus(false), 100)
        }}>
          <EditIcon />
          Edit
        </div>
      )}
      <div className='dropdownChild' onClick={() => {
        toggleMoveToCategoryModal(true, currentResponseDropdown)

        setTimeout(() => setResponseDropdoenStatus(false), 100)
      }}>
        <MoveToCategoryIcon />
        Move to category
      </div>

      {user.membership.user_type === 'admin' && currentResponseDropdown.category_id && currentResponseDropdown.pinned_to_category ? (
        <div className='dropdownChild' onClick={() => {
          pinToCategory(currentResponseDropdown);

          setTimeout(() => setResponseDropdoenStatus(false), 100)
        }}>
          <UnpinToCategoryIcon />
          Unpin to Category
        </div>
      ) : null}

      {user.membership.user_type === 'admin' && currentResponseDropdown.category_id && !currentResponseDropdown.pinned_to_category ? (
        <div className='dropdownChild' onClick={() => {
          pinToCategory(currentResponseDropdown)

          setTimeout(() => setResponseDropdoenStatus(false), 100)
        }}>
          <PinToCategoryIcon />
          Pin to Category
        </div>
      ) : null}

      {/* {user.membership.user_type === 'admin' && currentResponseDropdown.category_id && (
        <div className='dropdownChild' onClick={() => pinToCategory(currentResponseDropdown)}>
          {currentResponseDropdown.pinned_to_category ? (
            <>
              <UnpinToCategoryIcon />
              <span>Unpin to Category</span>
            </>
          ) : (
            <>
              <PinToCategoryIcon />
              <span>Pin to Category</span>
            </>
          )}
        </div>
      )} */}


      {checkUser_for_admin_or_owner(currentResponseDropdown, user) && (
        <div className='dropdownChild' id='delete' onClick={(e) => toggleDeleteContentModal(true, { ...currentResponseDropdown }, true)}>
          <DeleteIcon />
          Delete
        </div>
      )}
    </ResponseCardDropdownStyle>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isFree: state.company.company.isFree,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  is_subscribed: state.subscription.is_subscribed,
  showResponseDropdown: state.app.isResponseDropdownVisible,
  isCopyingLoading: state.app.isCopyingLoading,
  currentResponseDropdown: state.app.currentResponseDropdown
})

const mapDispatchToProps = (dispatch) => ({
  pinToCategory: (content) => dispatch(pinToCategory_action(content)),
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  toggleDeleteContentModal: (status, item, redirectToHome) => dispatch(toggleDeleteContentModal_action(status, item, redirectToHome)),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome)),
  toggleMoveToCategoryModal: (showMoveToCategoryModal, item) => dispatch(toggleMoveToCategoryModal_action(showMoveToCategoryModal, item)),
  setResponseDropdoenStatus: (status) => dispatch(setResponseDropdoenStatus(status)),
  setResponseDropdownPosition: (position) => dispatch(setResponseDropdownPosition(position)),
  setCurrentResponseDropdown: (response) => dispatch(setCurrentResponseDropdown(response)),
  setIsCopyingLoading: (status) => dispatch(setIsCopyingLoading(status)),

})

export default connect(mapStateToProps, mapDispatchToProps)(ResponseCardDropdown)